import { createTheme } from '@mui/material/styles';
import { colors, radius } from './designTokens';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.azure600,
      dark: colors.kale700,
      light: colors.azure500,
      contrastText: colors.textOnDark,
    },
    secondary: {
      main: colors.kale600,
      dark: colors.kale700,
      contrastText: colors.textOnDark,
    },
    background: {
      default: colors.grey100,
      paper: colors.surface,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    divider: colors.grey200,
  },
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Microsoft JhengHei"',
      '"微軟正黑體"',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
      color: colors.kale700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      color: colors.kale700,
    },
    h3: {
      fontWeight: 600,
      color: colors.kale600,
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.01em',
    },
  },
  shape: {
    borderRadius: radius.md,
  },
  shadows: [
    'none',
    colors.shadowSoft,
    colors.shadowCard,
    ...Array(22).fill(colors.shadowCard),
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.grey100,
          color: colors.textPrimary,
          minHeight: '100vh',
        },
        '#root': {
          minHeight: '100vh',
        },
        a: {
          color: colors.azure600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: radius.sm,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 20px',
          boxShadow: 'none',
        },
        containedPrimary: {
          backgroundColor: colors.azure600,
          '&:hover': {
            backgroundColor: colors.azure500,
            boxShadow: colors.shadowSoft,
          },
        },
        outlinedPrimary: {
          borderColor: colors.azure600,
          color: colors.azure600,
          '&:hover': {
            backgroundColor: colors.azure100,
            borderColor: colors.azure600,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: radius.md,
          backgroundImage: 'none',
          border: `1px solid ${colors.border}`,
        },
        elevation0: {
          border: 'none',
        },
        elevation1: {
          boxShadow: colors.shadowSoft,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: `${colors.grey200} !important`,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: radius.sm,
            backgroundColor: colors.surface,
            '& fieldset': {
              borderColor: colors.grey300,
            },
            '&:hover fieldset': {
              borderColor: colors.kale500,
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.azure600,
              borderWidth: 2,
            },
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.grey600,
          '&.Mui-checked': {
            color: colors.azure600,
          },
        },
      },
    },
  },
});

export default theme;
